import React from 'react';
import { Row, Col, FormControl, FormGroup, Panel, Button, HelpBlock, ProgressBar } from 'react-bootstrap';
// src
import { PostRequest } from '../../../../api/PostRequest.js';
import { NEW_ORDER_PATH } from '../../../../routes/routes_production.js';
import Prodotto from './Prodotto.js';
// css
import '../../../styles/commonStyles.css';

class PanelProdotti extends React.Component {
	constructor(props) {
		super(props);

    const { editMode, panProdotti } = this.props;   
   
    if(editMode) {
      let nrOfProducts = (Object.keys(panProdotti).length-5)/5;        

      let items = [];
      for(let i=0; i<nrOfProducts; i++) {        
        items.push({pos: i});
      }
      
      this.state = {        
        lastProductNumber: nrOfProducts-1,
        nrOfProducts: nrOfProducts,
        items: items,
        articles: null,
        editMode: true,
        lastProduct: null,
      }
    } else {
  		this.state = { 
  			lastProductNumber: 0,        
        nrOfProducts: 1, 
  			items: [{pos: 0}],
  			articles: null,     
        editMode: null,
        lastProduct: null,
  		};
    }

		this.addProduct = this.addProduct.bind(this);
    this.addProductAgain = this.addProductAgain.bind(this);
		this.removeProduct = this.removeProduct.bind(this);    
	}

	componentDidMount() {			    
		PostRequest(NEW_ORDER_PATH, {"request": "getArticles"})
      .then((res) => {             
        this.setState({articles: [res]});            
      })
      .catch((err) => { 
        console.log(err);          
      });
	}	

  render() {
    const { items, articles, nrOfProducts, editMode, lastProduct } = this.state;
    const { panProdotti } = this.props;
  	return (
  		<Col xs={12}>
		    <Panel>		      
		      <Panel.Heading>Prodotti</Panel.Heading>
		      <Panel.Body>     
		      	 <Row className="noNegativeMargin"> 		      		         
  			      	<Col xs={12} lg={4}>
  			        	<FormGroup>
  				          <label htmlFor="luceAttuale">Luce attuale</label>
  				          <FormControl 
  				            id="luceAttuale" name="luceAttuale" autoComplete="off"           
  				   					type="text" maxLength="50" 
                      data-caption="Luce attuale" data-separator="%%%Prodotti"                     
                      defaultValue={editMode? panProdotti['luceAttuale'] : ''}
  		          		/>	  
  		          		</FormGroup>
  			        </Col>

  			        <Col xs={12} lg={4}>
  			        	<FormGroup>
  				          <label htmlFor="reteAttuale">Rete attuale</label>
  				          <FormControl 
  				            id="reteAttuale" name="reteAttuale" autoComplete="off"            
  				   					type="text" maxLength="50" 
                      data-caption="Rete attuale"                      
                      defaultValue={editMode? panProdotti['reteAttuale'] : ''}
  		          		/>	  
  		          		</FormGroup>
  			        </Col>

  			        <Col xs={12} lg={4}>
  			        	<FormGroup>
  				          <label htmlFor="materassoAttuale">Materasso attuale</label>
  				          <FormControl 
  				            id="materassoAttuale" name="materassoAttuale" autoComplete="off"           
  				   					type="text" maxLength="50" 
                      data-caption="Materasso attuale"                      
                      defaultValue={editMode? panProdotti['materassoAttuale'] : ''}
  		          		/>	  
  		          		</FormGroup>
  			        </Col>                 
                
              </Row>

              <Row className="noNegativeMargin"> 		      		         
  			      	<Col xs={12} lg={2}>
  			        	<FormGroup>
  				          <label htmlFor="luceAttuale">Altezza piedini (cm)</label>
  				          <FormControl 
  				            id="numeroPiedini" name="numeroPiedini" autoComplete="off"           
  				   					type="number" data-caption="Altezza piedini (cm)"
                      defaultValue={editMode? panProdotti['numeroPiedini'] : ''}
  		          		/>	  
  		          		</FormGroup>
  			        </Col>

  			        <Col xs={12} lg={2}>
  			        	<FormGroup>
  				          <label htmlFor="reteAttuale">Altezza fianchi (cm)</label>
  				          <FormControl 
  				            id="numeroFianchi" name="numeroFianchi" autoComplete="off"            
  				   					type="number" data-caption="Altezza fianchi"                      
                      defaultValue={editMode? panProdotti['numeroFianchi'] : ''}
  		          		/>	  
  		          		</FormGroup>
  			        </Col>

  			        <Col xs={12} lg={8}>
  			        	<FormGroup>
  				          <label htmlFor="noteAggiuntive">Note prodotti</label>
  				          <FormControl 
  				            id="noteAggiuntive" name="noteAggiuntive" autoComplete="off"           
  				   					type="text" data-caption="noteAggiuntive"                      
                      defaultValue={editMode? panProdotti['noteAggiuntive'] : ''}
  		          		/>	  
  		          		</FormGroup>
  			        </Col>                 
                
              </Row>

              <Row className="noNegativeMargin">
                <Col xs={12}>
                  <HelpBlock>
                    Il campo <strong>Descrizione</strong> viene calcolato automaticamente 
                    selezionando un codice articolo esistente. <br/> 
                    Se inserisci manualmente un articolo e non selezioni la voce corrispondente, 
                    il campo rimane vuoto e l'ordine non può essere spedito.
                  </HelpBlock>
                </Col>                
              </Row>    
		        	{ articles!==null?
                items.map((item) => (
                  <Row className="noNegativeMargin" key={'row_'+item.pos}>
                    <Prodotto pos={item.pos} key={item.pos} 
                              nrOfProducts={nrOfProducts}
                              articles={articles}
                    					remove={this.removeProduct}
                              panProdotti={panProdotti}
                              lastProduct={lastProduct}
                              handleLast={this.addProductAgain}
                              editMode={editMode}                              
                    />
                  </Row>
                ))
                : 
                <Row className="noNegativeMargin">
                  <Col xs={12}>
                    <ProgressBar active bsStyle="success" now={100} label="Caricamento.." />
                  </Col>
                </Row>
              }  

              <Row className="noNegativeMargin">                
                <Col xs={12} lg={3}>
                  <FormGroup>            
                    <label htmlFor="aggiungiArticolo">Inserimento</label>                          
                      <Button 
                        className="btn-primary btn-outline" 
                        id="aggiungiArticolo" name="aggiungiArticolo"
                        onClick={this.addProduct} block>
                        Aggiungi nuovo
                      </Button>                                                 
                  </FormGroup> 
                </Col>                   
              </Row>             
		      </Panel.Body>
		        	
		    </Panel>
		  </Col>
  	);
  }  

  // Aggiungi nuovo
  addProduct() { 	
  	this.setState(prevState => ({  	
      nrOfProducts: prevState.nrOfProducts+1,	
  		lastProductNumber: prevState.lastProductNumber+1,
      items: [...prevState.items, { pos: prevState.lastProductNumber+1}],
      lastProduct: null,      
    }));
    // richiede di ricalcolare panel pagamento post inserimento
    this.props.toggleNeedsCalculation(true);
  }

  // Copia selezionato
  addProductAgain(lastProduct) {      
    this.setState(prevState => ({   
      nrOfProducts: prevState.nrOfProducts+1, 
      lastProductNumber: prevState.lastProductNumber+1,
      items: [...prevState.items, { pos: prevState.lastProductNumber+1}], 
      lastProduct: {
        "codArt": lastProduct[0],
        "description": lastProduct[1],
        "note": lastProduct[2],
        "fuoriMisura": lastProduct[3],
        "subGruppo": lastProduct[4],
        "peso": lastProduct[5]   
      }
    }));
    // richiede di ricalcolare panel pagamento post inserimento
    this.props.toggleNeedsCalculation(true);
  }

  removeProduct(e) {   
  	let items = [...this.state.items];
  	// rimuove il prefisso 'b_', ottenendo il valore di pos
  	const pos = (e.target.name).substr(2);
    // cerca l'indice dell'oggetto corrispondente nell'array    
  	const index = items.findIndex(item => item.pos==pos); 
  	// rimuove l'oggetto dall'array	
  	items.splice(index, 1); 
  	// aggiorna i prodotti
  	this.setState(prevState => ({  	
      nrOfProducts: prevState.nrOfProducts-1,
  		items: items
    })); 
    // richiede di ricalcolare panel pagamento post eliminazione
    this.props.toggleNeedsCalculation(true);
  }
}

export default PanelProdotti;


// WEBPACK FOOTER //
// ./src/cmp/Orders/Panels/PanelProdotti/PanelProdotti.js